
export const Loading = () => {
  return (
    <div className="bg-azul-0m h-screen w-full grid grid-rows-1">
        <div className="animate-bounce w-full flex-wrap content-center flex justify-center pt-24">
            <img className="w-[40px]" src="/assets/isotipo/isotipo.ico" alt="Isotipo" />
        </div>
        {/* <div>
            <p className="animate-pulse text-center font-thefontbold text-secondary">Loading...</p> 
        </div> */}
    </div>
  )
}
